import * as stylex from '@stylexjs/stylex';
import clsx from 'clsx';
import { ToggleSwitch } from '@/core/ToggleSwitch.atom';

import { sqWorkbenchStore } from '@/core/core.stores';
import { useFlux } from '@/core/hooks/useFlux.hook';
import { useSearchDatasources } from '@/search/search.store';
import { fcGear } from '@seeqdev/icons/seeq';
import { Icon } from '@seeqdev/qomponents';
import { colors } from '@seeqdev/qomponents/colors.stylex';

export interface DatasourcePreferencesToggleProps {
  on: boolean;
  onChange: () => void;
  formattedLabel: string;
  onClick: () => void;
  extraClassNames?: string;
  xstyle?: stylex.StyleXStyles;
}

export const DatasourcePreferencesToggle = ({
  on,
  onChange,
  formattedLabel,
  onClick,
  extraClassNames,
  xstyle,
}: DatasourcePreferencesToggleProps) => {
  const datasources = useSearchDatasources();
  const { includeNewDatasources, userDatasources } = useFlux(sqWorkbenchStore);

  const userHasCustomizedDatasourcePreferences =
    (userDatasources.length > 1 && includeNewDatasources) ||
    (userDatasources.length < datasources.length - 1 && !includeNewDatasources);
  return (
    <div
      data-testid="datasourcePreferencesToggleAndGear"
      {...stylex.props(styles.container, xstyle)}
      className={clsx(extraClassNames, stylex.props(styles.container, xstyle).className)}>
      {userHasCustomizedDatasourcePreferences && (
        <ToggleSwitch
          testId="datasourcePreferencesToggle"
          isOn={on}
          onChange={onChange}
          formattedLabel={<span {...stylex.props(styles.label)}>{formattedLabel}</span>}
        />
      )}
      <div onClick={onClick} {...stylex.props(styles.preferences)}>
        <Icon icon={fcGear} large={true} />
      </div>
    </div>
  );
};

const styles = stylex.create({
  label: { color: colors.legacyToolsLink },
  container: { display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end' },
  preferences: { cursor: 'pointer', marginBottom: '0.3125rem', marginLeft: '0.4375rem' },
});
